import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { deepCopy } from 'deep-copy-ts';
import { WindowService } from 'src/app/shared/components/window/window.service';
import { MitraNetworkParameters, ModeloDeAtendimento } from '../state/network-parameters.model.generated';
import { createSimulation, Simulation } from '../state/simulation.model';
import { SimulationService } from '../state/simulation.service';

@Component({
  templateUrl: './simulation-topology.component.html',
  styleUrls: ['./simulation-topology.component.scss']
})
export class SimulationTopologyComponent implements OnInit {

  parameters: MitraNetworkParameters;

  form: FormGroup;
  horizontalForm: FormGroup;
  horizontalCollectiveForm: FormGroup;
  verticalForm: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public simulation: Simulation,
    private simulationService: SimulationService,
    private windowService: WindowService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.createForm();

    if (this.simulation.parameters) {
      this.parameters = deepCopy(this.simulation.parameters);

      this.horizontalForm.patchValue({
        network_type: this.parameters.horizontal_settings.network_type
      });
    } else {
      this.parameters = createSimulation({}).parameters;
    }

  }

  horizontalBalancedUnbalancedToggle(type: ModeloDeAtendimento) {
    this.parameters.horizontal_settings.network_type = type;
    if (this.parameters.horizontal_settings.network_type === 'balanced') {
      this.parameters.horizontal_settings.bus_box_types.length = 0;
    }
    this.horizontalForm.patchValue({
      network_type: this.parameters.horizontal_settings.network_type
    });
  }

  finish(): void {
    const simulation = createSimulation(this.simulation);
    simulation.parameters = this.parameters;
    this.simulationService.update(this.simulation.id, simulation)
      .subscribe(s => this.windowService.close(this));
  }

  private createForm(): void {
    this.horizontalForm = this.fb.group({
      network_type: ['', Validators.required]
    });

    this.horizontalCollectiveForm = this.fb.group({});

    this.verticalForm = this.fb.group({});

    this.form = this.fb.group({
      horizontal: this.horizontalForm,
      horizontalCollectiveForm: this.horizontalCollectiveForm,
      vertical: this.verticalForm,
    });
  }

}
